import TealiumUTag from './TealiumUTag'

export const tealiumUTag = new TealiumUTag()
